<template>
  <Badge variant="discount">
    <slot />
  </Badge>
</template>
